import createTypedReducer from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

export interface CheckoutReviewAndSubmitStateType {
    readonly acceptTerms: boolean;
    readonly shipOrderComplete?: boolean;
}

export type CustomCheckoutReviewAndSubmitState = Readonly<CheckoutReviewAndSubmitStateType>;

export const initialCheckoutReviewAndSubmitState: CustomCheckoutReviewAndSubmitState = {
    acceptTerms: false,
};

export const customCheckoutReviewAndSubmitReducer = createTypedReducer(initialCheckoutReviewAndSubmitState, {
    "Custom/CheckoutReviewAndSubmitState/TermsFlag": (
        draft: Draft<CustomCheckoutReviewAndSubmitState>,
        { acceptTerms }: { acceptTerms: boolean },
    ) => ({
        ...draft,
        acceptTerms,
    }),
    "Custom/CheckoutReviewAndSubmitState/SetShipOrderComplete": (
        draft: Draft<CustomCheckoutReviewAndSubmitState>,
        { shipOrderComplete }: { shipOrderComplete: boolean },
    ) => ({
        ...draft,
        shipOrderComplete,
    }),
});
